import centers from "@/content/municipalityCenters.json";

const NAMES = {
  aquino: "Aquino", cassino: "Cassino", "cerro-al-volturno": "Cerro al Volturno",
  "acquaviva-isernia": "Acquaviva d’Isernia", pizzone: "Pizzone", lanciano: "Lanciano",
  bojano: "Bojano", isernia: "Isernia", frosolone: "Frosolone", "san-pietro-infine": "San Pietro Infine",
  venafro: "Venafro", "villa-santa-lucia": "Villa Santa Lucia", "sesto-campano": "Sesto Campano", termoli: "Termoli",
  brescia: "Brescia", frosinone: "Frosinone",
};

// User-approved city-level map references only; original project records stay intact.
const PROJECT_CITY_REFERENCES = {
  "gfc-alloggi-brescia": ["brescia"],
  "gfc-ss87-89-giro-italia": ["frosinone"],
};
// Exact canonical municipality labels only: never infer a precise worksite.
const AREAS = {
  "Aquino (FR)": ["aquino"], "Cassino (FR)": ["cassino"],
  "Cerro al Volturno, Acquaviva d’Isernia e Pizzone (IS)": ["cerro-al-volturno", "acquaviva-isernia", "pizzone"],
  "Lanciano (CH)": ["lanciano"], "Bojano (CB)": ["bojano"], "Isernia (IS)": ["isernia"],
  "Frosolone (IS)": ["frosolone"], "San Pietro Infine (CE)": ["san-pietro-infine"],
  "Venafro (IS)": ["venafro"], "Villa Santa Lucia (FR)": ["villa-santa-lucia"],
  "Sesto Campano (IS)": ["sesto-campano"], "Termoli (CB)": ["termoli"],
};

export function groupProjectLocations(projects) {
  const grouped = new Map();
  const unlocated = [];
  for (const project of projects) {
    const keys = PROJECT_CITY_REFERENCES[project.id] || AREAS[project.location];
    if (!keys) { unlocated.push(project); continue; }
    for (const key of keys) {
      if (!grouped.has(key)) grouped.set(key, { key, name: NAMES[key], position: [centers[key].lat, centers[key].lng], projects: [] });
      grouped.get(key).projects.push(project);
    }
  }
  return { groups: [...grouped.values()].sort((a, b) => a.name.localeCompare(b.name, "it")), unlocated, mappedCount: projects.length - unlocated.length };
}
